import PurposeSettingContainer from './PurposeSettingContainer';

/*
* 목표설정 화면
*/
export default PurposeSettingContainer;